export var formatCurrency = function (value) {
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    }).format(value);
};
export var formatNumber = function (value) {
    return new Intl.NumberFormat('pt-BR').format(value);
};
export var formatDate = function (dateString) {
    return new Date(dateString).toLocaleDateString('pt-BR');
};
